import { call, takeLatest, put } from 'redux-saga/effects';
import { DELETE_TASK_REQUEST, DeleteTaskRequestAction, deleteTaskFailureAction, deleteTaskSuccessAction, getTaskListRequestAction } from '../actions';
import { enqueueNotification } from 'store/modules/ui';
import { makeTaskManagementApi } from 'services/TaskManagementApi/TaskManagementApi';

export function* deleteTaskSaga(action: DeleteTaskRequestAction) {
  try {
    const taskManagementApi = makeTaskManagementApi();
    yield call(taskManagementApi.deleteTask, action.taskId); 
    yield put(deleteTaskSuccessAction());
    yield put(enqueueNotification({ message: 'Task deleted', options: { variant: 'success' } }));
    yield put(getTaskListRequestAction());
  } catch (e) {
    yield put(deleteTaskFailureAction());
    yield put(enqueueNotification({ message: 'Unable to delete task', options: { variant: 'error' } }));
  }
}

export function* watchDeleteTaskSaga() {
  yield takeLatest(
    [DELETE_TASK_REQUEST],
    deleteTaskSaga
  );
}
